module.exports = __webpack_public_path__ + "img/choose-up-11_1 virtual.bbd6fed9.png";